module.exports = __webpack_public_path__ + "static/media/4.4c7cccc3.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/home/case/cocina3/4.jpg
 ** module id = 620
 ** module chunks = 0
 **/